var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ActiveSubmenuContextProvider } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useS4XMastheadContext } from '../../S4XMastheadProvider';
import { useUserState } from '../hooks/useUserState';
import { FlyoutSubmenu } from '../FlyoutMenu/SubMenu';
import styled from 'styled-components';
import { cssSpacing } from '@spotify-internal/encore-web/core';
import { MAX_CONTENT_SCREEN_WIDTH, MAX_CONTENT_WIDTH } from '../../constants';
import { HomeLink } from '../../HomeLink/HomeLink';
import { NavBarLinks } from './Links';
import { NavBarActionsWithLanguage } from './ActionsWithLanguage';
import { NavBarWrapper } from './NavBarWrapper';
import { NavThemeProvider } from '../NavThemeProvider';
import { SecondaryNavContainer } from '../../SecondaryNav/SecondaryNavContainer';
import { NavBarHeight } from '../constants';
import SecondaryNav from '../../SecondaryNav';
import { SiteLogoWrapper } from '../SiteLogoWrapper';
var WrapperWide = styled(NavBarWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media (min-width: 1520px) {\n    padding-inline: ", ";\n  }\n  // max content width of 1524px\n  @media (min-width: ", ") {\n    padding-inline: calc((100% - ", ") / 2);\n  }\n"], ["\n  @media (min-width: 1520px) {\n    padding-inline: ", ";\n  }\n  // max content width of 1524px\n  @media (min-width: ", ") {\n    padding-inline: calc((100% - ", ") / 2);\n  }\n"])), cssSpacing('looser-3'), MAX_CONTENT_SCREEN_WIDTH, MAX_CONTENT_WIDTH);
export var NavBarWide = function (_a) {
    var forcedUserState = _a.forcedUserState, colors = _a.colors, className = _a.className;
    var userState = useUserState(forcedUserState);
    var _b = useS4XMastheadContext(), language = _b.language, mastheadData = _b.mastheadData, secondaryNavigation = _b.secondaryNavigation, siteLogo = _b.siteLogo;
    if (userState === 'loading' || !mastheadData) {
        return React.createElement("div", null);
    }
    var headerEntry = mastheadData.fields.header;
    return (React.createElement(ActiveSubmenuContextProvider, null,
        React.createElement(NavThemeProvider, { colors: colors },
            React.createElement(WrapperWide, { role: "banner", "data-testid": "navbar-state-".concat(userState), className: className },
                React.createElement(HomeLink, { label: headerEntry.fields.navBarLogoLabel },
                    React.createElement(SiteLogoWrapper, { component: siteLogo, label: headerEntry.fields.navBarLogoLabel, height: 36 })),
                React.createElement(NavBarLinks, { mastheadData: mastheadData, entries: headerEntry.fields.centerNav }),
                React.createElement(NavBarActionsWithLanguage, { language: language, userState: userState, mastheadData: mastheadData })),
            React.createElement(FlyoutSubmenu, null),
            secondaryNavigation && (React.createElement(SecondaryNavContainer, { fadeIn: true, primaryNavHeight: NavBarHeight, transitionIn: {
                    duration: 0.5,
                    ease: [0.5, 0, 0, 1]
                }, transitionOut: {
                    duration: 0.3,
                    ease: [0.5, 0, 0, 1]
                } },
                React.createElement(SecondaryNav, __assign({}, secondaryNavigation)))))));
};
var templateObject_1;
